export const CREATE_CUSTOMER_ADDRESS = /* GraphQL */ `
    mutation createCustomerAddress($address: CustomerAddressInput!) {
        createCustomerAddress(input: $address) {
            uid
            id
        }
    }
`
